import { Amplify } from 'aws-amplify';
import { noInterceptorApiClient } from 'common/client';
import { appEnvironment } from './appEnvironment';
import { tokenManager } from 'common/tokenManager';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: appEnvironment.amplify.userPoolId,
      userPoolClientId: appEnvironment.amplify.userPoolWebClientId,
    },
  },
});

export const login = async (email: string, password: string) => {
  const { data } = await noInterceptorApiClient.post<{
    accessToken: string;
    refreshToken: string;
  }>('/auth/login', {
    email,
    password,
  });

  await tokenManager.storeTokens(data);

  return {};
};
